import store from "@/store";

export function globalLoader(state) {
  store.commit(`system/SHOW_GLOBAL_LOADER`, state);
}

export function fixBody(state) {
  store.commit(`system/FIX_BODY`, state);
}

export const isMobile = {
  Android: () => navigator.userAgent.includes("Android"),
  BlackBerry: () => navigator.userAgent.includes("BlackBerry"),
  iOS: () =>
    navigator.userAgent.includes("iPhone") ||
    navigator.userAgent.includes("iPad") ||
    navigator.userAgent.includes("iPod"),
  Windows: () => navigator.userAgent.includes("IEMobile"),
  any: () => isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Windows(),
};

export const isIPad = {
  iOS: () => /iPad|iPod/i.test(navigator.userAgent),
};

export const pluralizate = (value, wordOne, wordSimple, wordMany) => {
  let language = store.getters.currentLanguage.translationKey;
  let localization = language && language.length > 2 ? language.slice(0, 2) : language;
  let pluralWord = '';

  if (localization === 'en') {
    pluralWord = value === 1 ? wordOne : wordSimple;
  } else if (localization === 'ru' || localization === 'ua') {
    pluralWord =
      value % 10 === 1 && value % 100 !== 11
        ? wordOne
        : value % 10 >= 2 && value % 10 <= 4 && (value % 100 < 10 || value % 100 >= 20)
          ? wordSimple
          : wordMany;
  }
  return pluralWord;
};
